import {Component, Input, OnInit} from '@angular/core';
import {ObjectComment, Severity} from '../../dto/object-comment';
import {ObjectCommentsService} from '../../home/services/object-comment.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {toDateTimeStringNoSeconds} from '../../providers/app-date-adapter';
import {MyAccountService} from "../../services/my-account.service";

@Component({
  selector: 'app-object-comments-view',
  templateUrl: './object-comments-view.component.html',
  styleUrls: ['./object-comments-view.component.css']
})
export class ObjectCommentsViewComponent implements OnInit {

  // None is disabled
  readonly severities = [Severity.Info, Severity.Success, Severity.Warning, Severity.Error, Severity.Critical]

  readonly severityNames = new Map<Severity, string>([
    [Severity.None, 'None'],
    [Severity.Info, 'Info'],
    [Severity.Warning, 'Warning'],
    [Severity.Success, 'Success'],
    [Severity.Error, 'Error'],
    [Severity.Critical, 'Critical'],
  ]);

  readonly severityColors = new Map<Severity, string>([
    [Severity.None, 'white'],
    [Severity.Info, '#0492c2'], // Cerulean
    [Severity.Warning, '#ec9706'], // Honey
    [Severity.Success, '#8bc34a'], // CardBro primary color
    [Severity.Error, '#be5504'], // Ginger
    [Severity.Critical, '#710c04'], // Blood
  ]);

  readonly severityIcons = new Map<Severity, string>([
    [Severity.None, 'circle'],
    [Severity.Info, 'info_outline'],
    [Severity.Warning, 'warning_amber'],
    [Severity.Success, 'check_circle_outline'],
    [Severity.Error, 'error_outline'],
    [Severity.Critical, 'error'],
  ]);

  @Input() comments: ObjectComment[];
  @Input() caption: string = 'Comments';
  @Input() objectId: number;
  @Input() target: number;

  currentUserEmail: string;

  newCommentText: string;
  newCommentSeverity: number = 1;

  constructor(
    private snackBar: MatSnackBar,
    private objectCommentsService: ObjectCommentsService,
    private myAccountService: MyAccountService,
  ) {
  }

  ngOnInit(): void {
    this.myAccountService.getCurrentUser().subscribe(user => {
      this.currentUserEmail = user?.userName;
    });
  }

  /**
   * Get additional info for the comment body like creation date and e-mail address of the user
   *
   * @param comment
   */
  getCommentInfo(comment: ObjectComment): string {
    if (!comment.date && !comment.user)
      return null;

    let datePart: string = toDateTimeStringNoSeconds(comment.date);

    let userPart: string = (comment.user?.firstName?.charAt(0) ?? '') +
      (comment.user?.lastName?.charAt(0) ?? '') +
      (comment.user?.firstName || comment.user?.lastName ? " (" : '') +
      (comment.user?.email ?? '') +
      (comment.user?.firstName || comment.user?.lastName ? ')' : '');

    return datePart + (comment.date && comment.user ? ", " : '') + userPart;
  }

  addObjectComment() {
    if (this.newCommentText.trim().length == 0) {
      this.showMessage('Can\'t add Empty or whitespaces-only Comments');
      return;
    }

    this.objectCommentsService
      .add(<ObjectComment>{
        Object: this.target,
        ObjectId: this.objectId,
        text: this.newCommentText,
        severity: this.newCommentSeverity,
      })
      .subscribe(_ => {
        this.newCommentText = '';
        this.refreshObjectComments();
      });
  }

  /**
   * Users can only delete their own comments and only if they are less than 5 minutes old.
   *
   * @param comment
   */
  canDeleteComment(comment: ObjectComment): boolean {
    return false;

    // MS 2024-02-05 deactivate for now.
    // TODO distinct between manual and automatic comments in backend


    // @ts-ignore TS sees "comment.date" as a Date object, JS as a string
    /*let dateDiffMilliseconds: number = Date.now() - Date.parse(comment.date);

    return comment.user && comment.user.email == this.currentUserEmail &&
      dateDiffMilliseconds > 0 && dateDiffMilliseconds < 300_000;*/
  }

  deleteObjectComment(id: number) {
    this.objectCommentsService.delete(id)
      .subscribe(_ => {
        this.refreshObjectComments();
      });
  }

  refreshObjectComments() {
    this.objectCommentsService.getForObject(this.objectId, this.target).subscribe(data => {
      this.comments = data;
    });
  }

  showMessage(msg: string) {
    this.snackBar.open(msg, null, {
      duration: 5000,
      panelClass: ['app-mat-snack-bar']
    });
  }

}
